import React from 'react';
import { Navigate } from 'react-router-dom';
import { permissionService, PermissionCode } from '../services/permissionService';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermissions?: PermissionCode[];
  requireAll?: boolean; // If true, requires all permissions; if false, requires any
  fallback?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermissions = [],
  requireAll = false,
  fallback = <Navigate to="/admin-dashboard" replace />
}) => {
  // If no permissions required, allow access
  if (requiredPermissions.length === 0) {
    return <>{children}</>;
  }

  // If permissions not loaded yet, show loading or fallback
  if (!permissionService.isLoaded()) {
    return <div>Loading permissions...</div>;
  }

  // Check permissions
  const hasPermission = requireAll
    ? permissionService.hasAllPermissions(requiredPermissions)
    : permissionService.hasAnyPermission(requiredPermissions);

  if (hasPermission) {
    return <>{children}</>;
  }

  // Return fallback if no permission
  return <>{fallback}</>;
};

export default ProtectedRoute;
